import { GridSortModel } from "@mui/x-data-grid";
import { ObraChecklistServicoLiberacao } from "../../domain/models/obra_checklist_servico_liberacao";
import { ObraChecklistServicoLiberacaoForm } from "../../presentation/schemas/Obras_checklistarea/obra_checklist_servico_liberacao";
import { Paginated } from "../../../../common/domain/models/paginated_models";
import { AtividadeObra } from "../../domain/models/atividade_obra";
import { AtividadeObraFuncionario } from "../../domain/models/atividade_obra_funcionario";
import { EmpreendimentoDropDown } from "../../domain/models/empreendimento";
import { EspecificidadeObra } from "../../domain/models/especificidade_obra";
import { IncorporacaoBloco } from "../../domain/models/incorporacao_bloco";
import { IncorporacaoBlocoDropDown } from "../../domain/models/incorporacao_bloco_dropdown";
import { IndicadorDropDown } from "../../domain/models/indicador_dropdown";
import { IndicadorObra } from "../../domain/models/indicador_obra";
import { MapaConcretagem, MapaConcretagemDetalhes } from "../../domain/models/mapa_concretagem";
import { MapaConcretagemFiltro } from "../../domain/models/mapa_concretagem_filtro";
import { Obra } from "../../domain/models/obra";
import { ObraAreaDropDown } from "../../domain/models/obra_area_dropdown";
import { ObraArquivo } from "../../domain/models/obra_arquivo";
import { ObraEstruturaOrganizacional } from "../../domain/models/obra_estrutura_organizacional";
import { ObraEstruturaOrganizacionalFuncionario } from "../../domain/models/obra_estrutura_organizacional_funcionario";
import { ObraInformacoes } from "../../domain/models/obra_informacoes";
import { ObraServicoDropDown } from "../../domain/models/obra_servico_dropdown";
import { IObrasRepository } from "../../domain/repositories/obras_repository";
import { IObrasService } from "../services/obras_service";
import { ObraHeaderInfo } from "../../domain/models/obra_header_info";
import { MonitoramentoChecklistEmpresa } from "../../domain/models/monitoramento_checklist_empresa";
import { MonitoramentoChecklistFuncionario } from "../../domain/models/monitoramento_checklist_funcionario";
import { ObraAreaChecklist } from "../../domain/models/obra_area_checklist";
import { ObraChecklistServicoDropDown } from "../../domain/models/obra_checklist_servico_dropdown";
import { StatInformation } from "../../domain/models/stat_information";
import { ObraAreaChecklistDropDown } from "../../domain/models/obra_area_checklist_dropdown";
import { PlanoTreinamentoListaFilter } from "../../domain/models/plano_treinamento_lista_filter";
import { PlanoTreinamentoLista } from "../../domain/models/plano_treinamento_lista";
import { AlvenariaEstruturalLista } from "../../domain/models/plano_alvenaria_estrutural_lista";
import { AlvenariaEstruturalListaFilter } from "../../domain/models/plano_alvenaria_estrutural_filter";
import {
  GetAllObrasGestaoDeResiduosData,
  GetAllObrasGestaoDeResiduosRequest,
  GetByidObrasGestaoDeResiduosResponse,
} from "../daos/read/get_all_obras_gestao_de_residuos";
import { CreateObrasGestaoDeResiduosRequest } from "../daos/create/create_obras_gestao_de_residuos";
import { UpdateObrasGestaoDeResiduosRequest } from "../daos/update/update_obras_gestao_de_residuos";
import { GetAllControleMateriaisRequest, GetAllControleMateriaisResponse } from "../daos/read/get_all_controle_materiais";
import { CreateControleMateriaisRequest } from "../daos/create/create_controle_materiais";
import { GetControleMateriaisByIdResponse } from "../daos/read/get_controle_materiais_by_id";
import { UpdateControleMateriaisRequest } from "../daos/update/update_controle_materiais";
import { GetAllControleServicosRequest, GetAllControleServicosResponse } from "../daos/read/get_all_controle_servicos";
import { CreateControleServicosRequest } from "../daos/create/create_controle_servicos";
import { GetControleServicosByIdResponse } from "../daos/read/get_controle_servicos_by_id";
import { UpdateControleServicosRequest } from "../daos/update/update_controle_servicos";
import { ObraAreaChecklistHeader } from "../../domain/models/obra_area_checklist_header";
import { ObraChecklistServico } from "../../domain/models/obra_checklist_servico";
import {
  GetAllObrasMateriaisControladosRequest,
  GetAllObrasMateriaisControladosResponse,
} from "../daos/read/get_all_obras_materiais_controlados_list";
import { GetObraMateriaisControladosDropDown } from "../daos/read/get_obra_materiais_controlados_dropdown";
import { CreateObraMateriaisControladosRequest } from "../daos/create/create_obra_materiais_controlados";
import {
  GetAllObrasServicosControladosRequest,
  GetAllObrasServicosControladosResponse,
} from "../daos/read/get_all_obras_servicos_controlados_list";
import { GetObraServicosControladosDropDown } from "../daos/read/get_obra_servicos_controlados_dropdown";
import { CreateObraServicosControladosRequest } from "../daos/create/create_obra_servicos_controlados";
import { ChecklistServicoDropDown } from "../../domain/models/checklist_servico_dropdown";
import { ObraChecklistServicoHeader } from "../../domain/models/obra_checklist_servico_header";
import { InspecaoObra } from "../../domain/models/inspecao_obra";
import { ObraChecklistServicoEstatisticas } from "../../domain/models/obra_checklist_servico_estatiticas";
import { ObraChecklistServicoCampos } from "../../domain/models/obra_checklist_servico_campos";
import { InspecaoObraDetalhes } from "../../domain/models/inspecao_obra_detalhes";
import { InspecaoObraItem } from "../../domain/models/inspecao_obra_item";
import { ExecutadoPor } from "../../domain/models/executador_por";
import { InspecaoObraOcorrencia } from "../../domain/models/inspecao_obra_ocorrencia";
import { GetAllAtributosObrasCadastroResponse } from "../daos/read/get_all_atributos_obras_cadastro";
import { ChecklistServico } from "../../domain/models/checklist_servico";
import { ChecklistServicoDetalhe } from "../../domain/models/checklist_servico_detalhe";
import { ItemChecklistServico } from "../../domain/models/item_checklist_servico";
import { EstatisticasChecklistServico } from "../../domain/models/estatisticas_checklist_servico";
import {
  GetAllControleResiduoRequestModel,
  GetAllControleResiduoResponseModel,
  GetControleResiduoByIdRequestModel,
  GetControleResiduoByIdResponseModel,
  CreateControleResiduoRequestModel,
  CreateControleResiduoResponseModel,
  UpdateControleResiduoRequestModel,
  UpdateControleResiduoResponseModel,
  DeleteControleResiduoRequestModel,
  DeleteControleResiduoResponseModel,
  GetAllControleEnergiaRequestModel,
  GetAllControleEnergiaResponseModel,
  GetControleEnergiaByIdRequestModel,
  GetControleEnergiaByIdResponseModel,
  CreateControleEnergiaRequestModel,
  CreateControleEnergiaResponseModel,
  UpdateControleEnergiaRequestModel,
  UpdateControleEnergiaResponseModel,
  DeleteControleEnergiaRequestModel,
  DeleteControleEnergiaResponseModel,
  GetAllControleAguaRequestModel,
  GetAllControleAguaResponseModel,
  GetControleAguaByIdRequestModel,
  GetControleAguaByIdResponseModel,
  CreateControleAguaRequestModel,
  CreateControleAguaResponseModel,
  UpdateControleAguaRequestModel,
  UpdateControleAguaResponseModel,
  DeleteControleAguaRequestModel,
  DeleteControleAguaResponseModel,
} from "../../domain/models/obras_sustentabilidade_model";
import { ManutencaoEquipObraLista } from "../../domain/models/manutencao_equip_obra_lista";
import { ManutencaoEquipObra } from "../../domain/models/manutencao_equip_obra";
import { DashboardObras } from "../../domain/models/dashboard_obras";
import { RestricoesPainelObra } from '../../domain/models/restricoes_painel_obra';
import { IndicadoresServicosObra } from "../../domain/models/indicadores_servicos_obra";
import { ChecklistServicoAmbienteModel } from "../../domain/models/checklist_servico_ambiente";
import { ReinspecaoEmAbertoLista } from "../../domain/models/reinspecao_em_aberto";
import { Empreendimento } from "../../../incorporacao/domain/models/empreendimento";
import { ChecklistServicoLiberacao } from "../../domain/models/checklist_servico_liberacao";

/**
 * ObrasRepository
 */

export class ObrasRepository implements IObrasRepository {
  constructor(private readonly service: IObrasService) { }

  async getEmpreendimentoDropdown(): Promise<EmpreendimentoDropDown[]> {
    const response = await this.service.getEmpreendimentoDropdown({});
    return response.itens;
  }

  async getIncorporacaoBlocoDropdown(idEmpreendimento: number): Promise<IncorporacaoBlocoDropDown[]> {
    const response = await this.service.getIncorporacaoBlocoDropdown({ idEmpreendimento });
    return response.itens;
  }

  async getObraEstruturaOrganizacionalFuncionarioDropdown(): Promise<ObraEstruturaOrganizacionalFuncionario[]> {
    const response = await this.service.getObraEstruturaOrganizacionalFuncionarioDropDown({});
    return response.itens;
  }

  async getAtividadeObraResponsavelDropdown(idFuncionarioResponsavel: number | null): Promise<AtividadeObraFuncionario[]> {
    const response = await this.service.getAtividadeObraResponsavelDropDown({
      idFuncionarioResponsavel: idFuncionarioResponsavel,
    });
    return response.itens;
  }

  async getAtividadeObraCorresponsavelDropdown(idFuncionarioCorresponsavel: number | null): Promise<AtividadeObraFuncionario[]> {
    const response = await this.service.getAtividadeObraCorresponsavelDropDown({
      idFuncionarioCorresponsavel: idFuncionarioCorresponsavel,
    });
    return response.itens;
  }

  async getIndicadorDropdown(idObra: number): Promise<IndicadorDropDown[]> {
    const response = await this.service.getIndicadorDropDown({ idObra });
    return response.itens;
  }

  async getObraAreaDropDown(idObra: number): Promise<ObraAreaDropDown[]> {
    const response = await this.service.getObraAreaDropDown({ idObra });
    return response.itens;
  }

  async getObraServicoDropDown(idObra: number): Promise<ObraServicoDropDown[]> {
    const response = await this.service.getObraServicoDropDown({ idObra });
    return response.itens;
  }

  async getMonitoramentoChecklistEmpresaDropDown(idObra: number): Promise<MonitoramentoChecklistEmpresa[]> {
    const response = await this.service.getMonitoramentoChecklistEmpresaDropDown({ idObra });
    return response.itens;
  }

  async getMonitoramentoChecklistFuncionarioDropDown(idObra: number): Promise<MonitoramentoChecklistFuncionario[]> {
    const response = await this.service.getMonitoramentoChecklistFuncionarioDropDown({ idObra });
    return response.itens;
  }

  async getObraChecklistServicosDropDown(
    idObra: number,
    tipoServico: string | null,
    idsObraAreaChecklist: number[] | null,
    usedOnly: boolean | null,
  ): Promise<ObraChecklistServicoDropDown[]> {
    const response = await this.service.getObraChecklistServicosDropDown({
      idObra,
      tipoServico,
      idsObraAreaChecklist,
      usedOnly,
    });
    return response.itens;
  }

  async getObraAreaChecklistDropDown(idObra: number, obraChecklistServicosIds: number[] | null): Promise<ObraAreaChecklistDropDown[]> {
    const response = await this.service.getObraAreaChecklistDropDown({
      idObra,
      obraChecklistServicosIds,
    });
    return response.itens;
  }

  async getChecklistServicosDropDown(
  ): Promise<ChecklistServicoDropDown[]> {
    const response = await this.service.getChecklistServicosDropDown({});
    return response.itens;
  }

  async getObraById(telaId: number, idObra: number): Promise<Obra | null> {
    const response = await this.service.getObraById({ telaId, idObra });
    return response.item;
  }

  async getAllObra(
    tipoPesquisa: number | null,
    valueField: string | null,
    statusDocumentos: number | null,
    resistenciaCompressao: number | null,
    statusEquipamentos: number | null,
    statusObras: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<Obra>> {
    return this.service.getAllObra({
      tipoPesquisa,
      valueField,
      statusDocumentos,
      resistenciaCompressao,
      statusEquipamentos,
      statusObras,
      page,
      rowsPerPage,
    });
  }

  async getEmpreendimentoByIdObra(idObra: number): Promise<Empreendimento | null> {
    const response = await this.service.getEmpreendimentoByIdObra({ idObra });
    return response.item;
  }

  async getIncorporacaoBlocosByIdLista(idIncorporacaoBlocoLista: number[]): Promise<IncorporacaoBloco[]> {
    const response = await this.service.getIncorporacaoBlocosByIdLista({
      idIncorporacaoBlocoLista,
    });
    return response.listaBlocos.map((x) => ({
      ...x,
      listaAndares:
        x.tipo === 1
          ? response.listaAndares
            .filter((y) => y.idIncorporacaoBloco === x.idIncorporacaoBloco)
            .map((y) => ({
              ...y,
              listaImoveis: response.listaImoveis.filter(
                (z) => z.idIncorporacaoAndar === y.idIncorporacaoAndar && z.idIncorporacaoBloco === y.idIncorporacaoBloco,
              ),
            }))
          : undefined,
      listaImoveis: x.tipo !== 1 ? response.listaImoveis.filter((y) => y.idIncorporacaoBloco === x.idIncorporacaoBloco) : undefined,
    }));
  }

  async createObra(
    tipo: number,
    idFuncionarioAprovado: number | null,
    idFuncionarioRevisado: number | null,
    idCentroCusto: number | null,
    idEmpreendimento: number | null,
    historicoRevisoes: string | null,
    apresentacaoObra: string | null,
    processo: string | null,
    pctPdeFadDatec: string | null,
    meios: string | null,
    imgEo: string | null,
    imgCo: string | null,
    extEo: string | null,
    extCo: string | null,
  ): Promise<number> {
    const response = await this.service.createObra({
      tipo,
      idFuncionarioAprovado,
      idFuncionarioRevisado,
      idCentroCusto,
      idEmpreendimento,
      historicoRevisoes,
      apresentacaoObra,
      processo,
      pctPdeFadDatec,
      meios,
      imgEo,
      imgCo,
      extEo,
      extCo,
    });

    return response.idObra;
  }

  async updateObra(
    idObra: number,
    tipo: number,
    idFuncionarioAprovado: number | null,
    idFuncionarioRevisado: number | null,
    idCentroCusto: number | null,
    idEmpreendimento: number | null,
    historicoRevisoes: string | null,
    apresentacaoObra: string | null,
    processo: string | null,
    pctPdeFadDatec: string | null,
    meios: string | null,
    imgEo: string | null,
    imgCo: string | null,
    extEo: string | null,
    extCo: string | null,
    limparImgEo: boolean,
    limparImgCo: boolean,
  ): Promise<void> {
    await this.service.updateObra({
      idObra,
      tipo,
      idFuncionarioAprovado,
      idFuncionarioRevisado,
      idCentroCusto,
      idEmpreendimento,
      historicoRevisoes,
      apresentacaoObra,
      processo,
      pctPdeFadDatec,
      meios,
      imgEo,
      imgCo,
      extEo,
      extCo,
      limparImgEo,
      limparImgCo,
    });
  }

  async deleteObra(idTela: number, idObra: number): Promise<void> {
    await this.service.deleteObra({
      idTela,
      idObra,
    });
  }

  async copyObra(idObra: number, idCentroCusto: number, copiarChecklist: number): Promise<void> {
    await this.service.copyObra({
      idObra,
      idCentroCusto,
      copiarChecklist,
    });
  }

  async getAllObraEstruturaOrganizacional(
    idObra: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ObraEstruturaOrganizacional>> {
    return await this.service.getAllObraEstruturaOrganizacional({
      idObra,
      page,
      rowsPerPage,
    });
  }

  async createObraEstruturaOrganizacional(idObra: number, idFuncionario: number, idCargo: number): Promise<void> {
    await this.service.createObraEstruturaOrganizacional({
      idObra,
      idFuncionario,
      idCargo,
    });
  }

  async updateObraEstruturaOrganizacional(idEstruturaOrganizacional: number, idFuncionario: number, idCargo: number): Promise<void> {
    await this.service.updateObraEstruturaOrganizacional({
      idEstruturaOrganizacional,
      idFuncionario,
      idCargo,
    });
  }

  async deleteObraEstruturaOrganizacional(idEstruturaOrganizacional: number): Promise<void> {
    await this.service.deleteObraEstruturaOrganizacional({
      idEstruturaOrganizacional,
    });
  }

  //#region  Plano Treinamento

  async getAllObraEstruturaTreinamento(
    filter: PlanoTreinamentoListaFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<PlanoTreinamentoLista>> {
    const response = await this.service.getAllObraEstruturaTreinamento({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): PlanoTreinamentoLista => ({
          IdObra: item.idObra,
          IdPlanoTreinamento: item.idPlanoTreinamento,
          Cargo: item.cargo,
          TipoTreinamento: item.tipoTreinamento,
        }),
      ),
    };
  }

  async createObraPlanoTreinamento(ID_OBRA: number, TIPO_TREINAMENTO: string, Cargo: string): Promise<void> {
    await this.service.createObraPlanoTreinamento({
      ID_OBRA,
      Cargo,
      TIPO_TREINAMENTO,
    });
  }

  async deleteObraPlanoTreinamento(IdPlanoTreinamento: number, idObra: number): Promise<void> {
    await this.service.deleteObraPlanoTreinamento({
      IdPlanoTreinamento,
      idObra,
    });
  }

  async updateObraPlanoTreinamento(idObra: number, IdPlanoTreinamento: number, Cargo: string, TipoTreinamento: string): Promise<void> {
    await this.service.updateObraPlanoTreinamento({
      idObra,
      IdPlanoTreinamento,
      Cargo,
      TipoTreinamento,
    });
  }

  //#endregion

  //#region AlvenariaEstrututal
  async createAlvenariaEstrutural(
    IdObra: number,
    TipoBloco: string,
    Dimensao: string,
    Fornecedor: string,
    LocalAplicacao: string,
    QtdeRecibida: string,
    NrAmostras: string,
    NroNotaFiscal: string,
    NomeLaboratorio: string,
    EspecificacaoArgamassa: string,
    EnsaiosSolicitados: string,
    DataRecebimento: Date | null,
    DataEnvio: Date | null,
    ResponsavelCadastrado: boolean,
    DescResponsavel: string,
    IdFuncionario: number | null,
    Observacao: string,
    Ensaio1: string,
    Ensaio2: string,
    NroAmostras1: string,
    NroAmostras2: string,
    RbIdade1: string,
    RbIdade2: string,
    RbIdade3: string,
    RbResultado1: string,
    RbResultado2: string,
    RbResultado3: string,
    RaIdade1: string,
    RaIdade2: string,
    RaIdade3: string,
    RaResultado1: string,
    RaResultado2: string,
    RaResultado3: string,
    Aprovado: boolean,
    Arquivo1: File | null,
    Arquivo2: File | null,
    NrCorpoProva: string | null,
    ResistenciaSolicitada: string | null
  ): Promise<void> {
    await this.service.createAlvenariaEstrutural({
      IdObra,
      TipoBloco,
      Dimensao,
      Fornecedor,
      LocalAplicacao,
      QtdeRecibida,
      NrAmostras,
      NroNotaFiscal,
      NomeLaboratorio,
      EspecificacaoArgamassa,
      EnsaiosSolicitados,
      DataRecebimento,
      DataEnvio,
      ResponsavelCadastrado,
      DescResponsavel,
      IdFuncionario,
      Observacao,
      Ensaio1,
      Ensaio2,
      NroAmostras1,
      NroAmostras2,
      RbIdade1,
      RbIdade2,
      RbIdade3,
      RbResultado1,
      RbResultado2,
      RbResultado3,
      RaIdade1,
      RaIdade2,
      RaIdade3,
      RaResultado1,
      RaResultado2,
      RaResultado3,
      Aprovado,
      Arquivo1,
      Arquivo2,
      NrCorpoProva,
      ResistenciaSolicitada
    });
  }

  async getAllObrasAlvenariaEstrutural(
    filter: AlvenariaEstruturalListaFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<AlvenariaEstruturalLista>> {
    const response = await this.service.getAllObrasAlvenariaEstrutural({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): AlvenariaEstruturalLista => ({
          IdObra: item.idObra,
          IdAlvenariaObra: item.idAlvenariaObra,
          DataRecebimento: item.dataRecebimento,
          Dimensao: item.dimensao,
          TipoBloco: item.tipoBloco,
          NroNotaFiscal: item.nroNotaFiscal,
          ResistenciaSolicitada: item.resistenciaSolicitada,
          QtdeRecibida: item.qtdeRecibida,
          Fornecedor: item.fornecedor,
          LocalAplicacao: item.localAplicacao,
          NomeLaboratorio: item.nomeLaboratorio,
          DataEnvio: item.dataEnvio,
          Aprovado: item.aprovado,
          FuncionarioNome: item.funcionarioNome,
          IdFuncionario: item.idFuncionario,
          NomeArquivo1: item.nomeArquivo1,
          NomeArquivo2: item.nomeArquivo2,
          Ensaio1: item.ensaio1,
          Ensaio2: item.ensaio2,
          EnsaiosSolicitados: item.ensaiosSolicitados,
          EspecificacaoArgamassa: item.especificacaoArgamassa,
          NrAmostras: item.nrAmostras,
          NrCorpoProva: item.nrCorpoProva,
          NroAmostras1: item.nroAmostras1,
          NroAmostras2: item.nroAmostras2,
          Observacao: item.observacao,
          DescResponsavel: item.descResponsavel,
          RaIdade1: item.raIdade1,
          RaIdade2: item.raIdade2,
          RaIdade3: item.raIdade3,
          RaResultado1: item.raResultado1,
          RaResultado2: item.raResultado2,
          RaResultado3: item.raResultado3,
          RbIdade1: item.rbIdade1,
          RbIdade2: item.rbIdade2,
          RbIdade3: item.rbIdade3,
          RbResultado1: item.rbResultado1,
          RbResultado2: item.rbResultado2,
          RbResultado3: item.rbResultado3,
          ResponsavelCadastrado: item.responsavelCadastrado,

        }),
      ),
    };
  }

  async updateAlvenariaEstrutural(
    IdObra: number,
    IdAlvenariaObra: number,
    TipoBloco: string,
    Dimensao: string,
    Fornecedor: string,
    LocalAplicacao: string,
    QtdeRecibida: string,
    NrAmostras: string,
    NroNotaFiscal: string,
    NomeLaboratorio: string,
    EspecificacaoArgamassa: string,
    EnsaiosSolicitados: string,
    DataRecebimento: Date | null,
    DataEnvio: Date | null,
    ResponsavelCadastrado: boolean,
    DescResponsavel: string,
    IdFuncionario: number | null,
    Observacao: string,
    Ensaio1: string,
    Ensaio2: string,
    NroAmostras1: string,
    NroAmostras2: string,
    RbIdade1: string,
    RbIdade2: string,
    RbIdade3: string,
    RbResultado1: string,
    RbResultado2: string,
    RbResultado3: string,
    RaIdade1: string,
    RaIdade2: string,
    RaIdade3: string,
    RaResultado1: string,
    RaResultado2: string,
    RaResultado3: string,
    Aprovado: boolean,
    Arquivo1: File | null,
    Arquivo2: File | null,
    NrCorpoProva: string | null,
    ResistenciaSolicitada: string | null,
    limparArquivo1: boolean,
    limparArquivo2: boolean,
  ): Promise<void> {
    await this.service.updateAlvenariaEstrutural({
      IdObra,
      IdAlvenariaObra,
      TipoBloco,
      Dimensao,
      Fornecedor,
      LocalAplicacao,
      QtdeRecibida,
      NrAmostras,
      NroNotaFiscal,
      NomeLaboratorio,
      EspecificacaoArgamassa,
      EnsaiosSolicitados,
      DataRecebimento,
      DataEnvio,
      ResponsavelCadastrado,
      DescResponsavel,
      IdFuncionario,
      Observacao,
      Ensaio1,
      Ensaio2,
      NroAmostras1,
      NroAmostras2,
      RbIdade1,
      RbIdade2,
      RbIdade3,
      RbResultado1,
      RbResultado2,
      RbResultado3,
      RaIdade1,
      RaIdade2,
      RaIdade3,
      RaResultado1,
      RaResultado2,
      RaResultado3,
      Aprovado,
      Arquivo1,
      Arquivo2,
      NrCorpoProva,
      ResistenciaSolicitada,
      limparArquivo1,
      limparArquivo2,
    });
  }

  async deleteObraAlvenariaEstrutural(IdAlvenariaObra: number, idObra: number): Promise<void> {
    await this.service.deleteObraAlvenariaEstrutural({
      IdAlvenariaObra,
      idObra,
    });
  }
  //#endregion
  async getAllAtividadeObra(idObra: number, page: number, rowsPerPage: number): Promise<Paginated<AtividadeObra>> {
    return await this.service.getAllAtividadeObra({
      idObra,
      page,
      rowsPerPage,
    });
  }

  async createAtividadeObra(
    idObra: number,
    atividade: string,
    idFuncionarioResponsavel: number | null,
    funcionarioResponsavel: string | null,
    idFuncionarioCorresponsavel: number | null,
    funcionarioCorresponsavel: string | null,
  ): Promise<void> {
    await this.service.createAtividadeObra({
      idObra,
      atividade,
      idFuncionarioResponsavel,
      funcionarioResponsavel,
      idFuncionarioCorresponsavel,
      funcionarioCorresponsavel,
    });
  }

  async updateAtividadeObra(
    idAtividadeObra: number,
    atividade: string,
    idFuncionarioResponsavel: number | null,
    funcionarioResponsavel: string | null,
    idFuncionarioCorresponsavel: number | null,
    funcionarioCorresponsavel: string | null,
  ): Promise<void> {
    await this.service.updateAtividadeObra({
      idAtividadeObra,
      atividade,
      idFuncionarioResponsavel,
      funcionarioResponsavel,
      idFuncionarioCorresponsavel,
      funcionarioCorresponsavel,
    });
  }

  async deleteAtividadeObra(idAtividadeObra: number): Promise<void> {
    await this.service.deleteAtividadeObra({
      idAtividadeObra,
    });
  }

  async getAllEspecificidadeObra(idObra: number, page: number, rowsPerPage: number): Promise<Paginated<EspecificidadeObra>> {
    return await this.service.getAllEspecificidadeObra({
      idObra,
      page,
      rowsPerPage,
    });
  }

  async createEspecificidadeObra(idObra: number, item: string, formaControle: string): Promise<void> {
    await this.service.createEspecificidadeObra({
      idObra,
      item,
      formaControle,
    });
  }

  async updateEspecificidadeObra(idEspecificidadeObra: number, item: string, formaControle: string): Promise<void> {
    await this.service.updateEspecificidadeObra({
      idEspecificidadeObra,
      item,
      formaControle,
    });
  }

  async deleteEspecificidadeObra(idEspecificidadeObra: number): Promise<void> {
    await this.service.deleteEspecificidadeObra({
      idEspecificidadeObra,
    });
  }

  async getAllIndicadorObra(idObra: number, page: number, rowsPerPage: number): Promise<Paginated<IndicadorObra>> {
    return await this.service.getAllIndicadorObra({
      idObra,
      page,
      rowsPerPage,
    });
  }

  async createIndicadorObra(idObra: number, idIndicadores: number[]): Promise<void> {
    await this.service.createIndicadorObra({
      idObra,
      idIndicadores,
    });
  }

  async updateIndicadorObra(
    idObraIndicador: number,
    resultado: string | null,
  ): Promise<void> {
    await this.service.updateIndicadorObra({
      idObraIndicador,
      resultado,
    });
  }

  async deleteIndicadorObra(idObraIndicador: number): Promise<void> {
    await this.service.deleteIndicadorObra({
      idObraIndicador,
    });
  }

  async getAllObraArquivo(
    idObra: number,
    status: number | null,
    situacao: number | null,
    nomeDescricao: string | null,
    dataVencimento: (Date | null)[] | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ObraArquivo>> {
    return await this.service.getAllObraArquivo({
      idObra,
      status,
      situacao,
      nomeDescricao,
      dataVencimento,
      page,
      rowsPerPage,
    });
  }

  async createObraArquivo(
    idObra: number,
    obsoleto: boolean,
    nomeDocumento: string,
    arquivoNome: string,
    Arquivo: string,
    dataVencimento: Date | null,
  ): Promise<void> {
    await this.service.createObraArquivo({
      idObra,
      obsoleto,
      nomeDocumento,
      arquivoNome,
      Arquivo,
      dataVencimento,
    });
  }

  async updateObraArquivo(
    idObraArquivo: number,
    obsoleto: boolean,
    nomeDocumento: string,
    arquivoNome: string | null,
    arquivo: string | null,
    dataVencimento: Date | null,
  ): Promise<void> {
    await this.service.updateObraArquivo({
      idObraArquivo,
      obsoleto,
      nomeDocumento,
      arquivoNome,
      arquivo,
      dataVencimento,
    });
  }

  async deleteObraArquivo(idObraArquivo: number): Promise<void> {
    await this.service.deleteObraArquivo({ idObraArquivo });
  }

  async getAllObraInformacoes(
    idObra: number,
    data: Date | null,
    informacoes: string | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ObraInformacoes>> {
    return await this.service.getAllObraInformacoes({
      idObra,
      data,
      informacoes,
      page,
      rowsPerPage,
    });
  }

  async createObraInformacoes(idObra: number, idFuncionario: number, data: Date, descInformacoes: string): Promise<void> {
    await this.service.createObraInformacoes({
      idObra,
      idFuncionario,
      data,
      descInformacoes,
    });
  }

  async updateObraInformacoes(idObraInformacoes: number, idFuncionario: number, data: Date, descInformacoes: string): Promise<void> {
    await this.service.updateObraInformacoes({
      idObraInformacoes,
      idFuncionario,
      data,
      descInformacoes,
    });
  }

  async deleteObraInformacoes(idObraInformacoes: number): Promise<void> {
    await this.service.deleteObraInformacoes({
      idObraInformacoes,
    });
  }

  async getMapaConcretagemFiltro(): Promise<MapaConcretagemFiltro | null> {
    const response = await this.service.getMapaConcretagemFiltro({});
    return response.item;
  }

  async saveMapaConcretagemFiltro(idObra: number, colunas: string): Promise<void> {
    await this.service.saveMapaConcretagemFiltro({
      idObra,
      colunas,
    });
  }

  async sendEmail(idObra: number, emails: string[], subject: string, body: string, attachment: string): Promise<void> {
    await this.service.sendEmail({
      idObra,
      emails,
      subject,
      body,
      attachment,
    });
  }


  async getAllMapaConcretagem(
    idObra: number,
    dataDe: Date | null,
    dataAte: Date | null,
    localLancamento: string | null,
    resistencia: string | null,
    nroNotaFiscal: string | null,
    statusRompimento: number | null,
    enviadoLab: number | null,
    nroLaudo: string | null,
    aprovado: number | null,
    sorting: GridSortModel | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<MapaConcretagem>> {
    return await this.service.getAllMapaConcretagem({
      idObra,
      dataDe,
      dataAte,
      localLancamento,
      resistencia,
      nroNotaFiscal,
      statusRompimento,
      enviadoLab,
      nroLaudo,
      aprovado,
      sorting,
      page,
      rowsPerPage,
    });
  }

  async getMapaConcretagemById(idMapaConcretagem: number): Promise<MapaConcretagemDetalhes | null> {
    const response = await this.service.getMapaConcretagemById({
      idMapaConcretagem,
    });
    return response.item;
  }

  async createMapaConcretagem(
    idObra: number,
    dataConcretagem: Date,
    tipoConcreto: string | null,
    slupFlowSolicitado: string | null,
    resistMpa: string | null,
    ensaioConcreto: number | null,
    idFornecedor: number | null,
    fornecedor: string | null,
    nroCarro: string | null,
    nroNotaFiscal: string | null,
    saidaUsina: number | null,
    entradaObra: number | null,
    inicioLancamento: number | null,
    finalLancamento: number | null,
    qteM3: string | null,
    slumpFlowEncontrado: string | null,
    localLancamento: string,
    dataEnvioObra: Date | null,
    idLaboratorio: number | null,
    laboratorio: string | null,
    nroCorpoProva: string | null,
    nroLote: string | null,
    instrucaoLancamento: string | null,
    enviadoLaboratorio: boolean | null,
    dataEnviadoLaboratorio: Date | null,
    resistencia12hs: string | null,
    resistencia12hsCheckbox: boolean | null,
    resistencia4: string | null,
    resistencia4Checkbox: boolean | null,
    resistencia7: string | null,
    resistencia7Checkbox: boolean | null,
    resistencia14: string | null,
    resistencia14Checkbox: boolean | null,
    resistencia21: string | null,
    resistencia21Checkbox: boolean | null,
    resistencia28: string | null,
    resistencia28Checkbox: boolean | null,
    resistencia56: string | null,
    resistencia56Checkbox: boolean | null,
    resistencia63: string | null,
    resistencia63Checkbox: boolean | null,
    idade1: string | null,
    resultado1: string | null,
    idade2: string | null,
    resultado2: string | null,
    idade3: string | null,
    resultado3: string | null,
    aprovado: boolean | null,
    dataAprovacao: Date | null,
    idResponsavelAprovacao: number | null,
    responsavelAprovacao: string | null,
    observacao: string | null,
    arquivo1: File | null,
    arquivo2: File | null,
    arquivo3: File | null,
    arquivo4: File | null,
    moduloResistenciaGPA: string | null,
    ensaioModuloElasticidade: boolean | null,
    nroLaudo: string | null,
    checkElasticidade28: boolean | null,
    elasticidade28: string | null,
  ): Promise<number> {
    const response = await this.service.createMapaConcretagem({
      idObra,
      dataConcretagem,
      tipoConcreto,
      slupFlowSolicitado,
      resistMpa,
      ensaioConcreto,
      idFornecedor,
      fornecedor,
      nroCarro,
      nroNotaFiscal,
      saidaUsina,
      entradaObra,
      inicioLancamento,
      finalLancamento,
      qteM3,
      slumpFlowEncontrado,
      localLancamento,
      dataEnvioObra,
      idLaboratorio,
      laboratorio,
      nroCorpoProva,
      nroLote,
      instrucaoLancamento,
      enviadoLaboratorio,
      dataEnviadoLaboratorio,
      resistencia12hs,
      resistencia12hsCheckbox,
      resistencia4,
      resistencia4Checkbox,
      resistencia7,
      resistencia7Checkbox,
      resistencia14,
      resistencia14Checkbox,
      resistencia21,
      resistencia21Checkbox,
      resistencia28,
      resistencia28Checkbox,
      resistencia56,
      resistencia56Checkbox,
      resistencia63,
      resistencia63Checkbox,
      idade1,
      resultado1,
      idade2,
      resultado2,
      idade3,
      resultado3,
      aprovado,
      dataAprovacao,
      idResponsavelAprovacao,
      responsavelAprovacao,
      observacao,
      arquivo1,
      arquivo2,
      arquivo3,
      arquivo4,
      moduloResistenciaGPA,
      ensaioModuloElasticidade,
      nroLaudo,
      checkElasticidade28,
      elasticidade28,
    });
    return response.idMapaConcretagem;
  }

  async updateMapaConcretagem(
    idMapaConcretagem: number,
    dataConcretagem: Date,
    tipoConcreto: string | null,
    slupFlowSolicitado: string | null,
    resistMpa: string | null,
    ensaioConcreto: number | null,
    idFornecedor: number | null,
    fornecedor: string | null,
    nroCarro: string | null,
    nroNotaFiscal: string | null,
    saidaUsina: number | null,
    entradaObra: number | null,
    inicioLancamento: number | null,
    finalLancamento: number | null,
    qteM3: string | null,
    slumpFlowEncontrado: string | null,
    localLancamento: string,
    dataEnvioObra: Date | null,
    idLaboratorio: number | null,
    laboratorio: string | null,
    nroCorpoProva: string | null,
    nroLote: string | null,
    instrucaoLancamento: string | null,
    enviadoLaboratorio: boolean | null,
    dataEnviadoLaboratorio: Date | null,
    resistencia12hs: string | null,
    resistencia12hsCheckbox: boolean | null,
    resistencia4: string | null,
    resistencia4Checkbox: boolean | null,
    resistencia7: string | null,
    resistencia7Checkbox: boolean | null,
    resistencia14: string | null,
    resistencia14Checkbox: boolean | null,
    resistencia21: string | null,
    resistencia21Checkbox: boolean | null,
    resistencia28: string | null,
    resistencia28Checkbox: boolean | null,
    resistencia56: string | null,
    resistencia56Checkbox: boolean | null,
    resistencia63: string | null,
    resistencia63Checkbox: boolean | null,
    idade1: string | null,
    resultado1: string | null,
    idade2: string | null,
    resultado2: string | null,
    idade3: string | null,
    resultado3: string | null,
    aprovado: boolean | null,
    dataAprovacao: Date | null,
    idResponsavelAprovacao: number | null,
    responsavelAprovacao: string | null,
    observacao: string | null,
    arquivo1: File | null,
    limparArquivo1: boolean,
    arquivo2: File | null,
    limparArquivo2: boolean,
    arquivo3: File | null,
    limparArquivo3: boolean,
    arquivo4: File | null,
    limparArquivo4: boolean,
    moduloResistenciaGPA: string | null,
    ensaioModuloElasticidade: boolean | null,
    nroLaudo: string | null,
    checkElasticidade28: boolean | null,
    elasticidade28: string | null,
  ): Promise<void> {
    await this.service.updateMapaConcretagem({
      idMapaConcretagem,
      dataConcretagem,
      tipoConcreto,
      slupFlowSolicitado,
      resistMpa,
      ensaioConcreto,
      idFornecedor,
      fornecedor,
      nroCarro,
      nroNotaFiscal,
      saidaUsina,
      entradaObra,
      inicioLancamento,
      finalLancamento,
      qteM3,
      slumpFlowEncontrado,
      localLancamento,
      dataEnvioObra,
      idLaboratorio,
      laboratorio,
      nroCorpoProva,
      nroLote,
      instrucaoLancamento,
      enviadoLaboratorio,
      dataEnviadoLaboratorio,
      resistencia12hs,
      resistencia12hsCheckbox,
      resistencia4,
      resistencia4Checkbox,
      resistencia7,
      resistencia7Checkbox,
      resistencia14,
      resistencia14Checkbox,
      resistencia21,
      resistencia21Checkbox,
      resistencia28,
      resistencia28Checkbox,
      resistencia56,
      resistencia56Checkbox,
      resistencia63,
      resistencia63Checkbox,
      idade1,
      resultado1,
      idade2,
      resultado2,
      idade3,
      resultado3,
      aprovado,
      dataAprovacao,
      idResponsavelAprovacao,
      responsavelAprovacao,
      observacao,
      arquivo1,
      limparArquivo1,
      arquivo2,
      limparArquivo2,
      arquivo3,
      limparArquivo3,
      arquivo4,
      limparArquivo4,
      moduloResistenciaGPA,
      ensaioModuloElasticidade,
      nroLaudo,
      checkElasticidade28,
      elasticidade28,
    });
  }

  async deleteMapaConcretagem(idMapaConcretagem: number): Promise<void> {
    await this.service.deleteMapaConcretagem({
      idMapaConcretagem,
    });
  }

  async copyMapaConcretagem(idMapaConcretagem: number, copyNumber: number): Promise<void> {
    await this.service.copyMapaConcretagem({
      idMapaConcretagem,
      copyNumber,
    });
  }

  async getObraHeaderInfo(idObra: number): Promise<ObraHeaderInfo | null> {
    const response = await this.service.getObraHeaderInfo({ idObra });
    return response.item;
  }

  async getAllObraAreaChecklist(
    idObra: number,
    area: string | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ObraAreaChecklist>> {
    return await this.service.getAllObraAreaChecklist({
      idObra,
      area,
      status,
      page,
      rowsPerPage,
    });
  }

  async createObraAreaChecklist(idObra: number, status: number, area: string, checklists: number[] | null): Promise<void> {
    await this.service.createObraAreaChecklist({
      idObra,
      status,
      area,
      checklists,
    });
  }

  async createObraAreaEmpreendimentoChecklist(
    idObra: number,
    status: number,
    idIncorporacaoBloco: number,
    idIncorporacaoAndar: number | null,
    unidade: string,
    checklists: number[] | null,
  ): Promise<void> {
    await this.service.createObraAreaEmpreendimentoChecklist({
      idObra,
      status,
      idIncorporacaoBloco,
      idIncorporacaoAndar,
      unidade,
      checklists,
    });
  }

  async updateObraAreaChecklist(idObraAreaChecklist: number, status: number, area: string, checklists: number[] | null): Promise<void> {
    await this.service.updateObraAreaChecklist({
      idObraAreaChecklist,
      status,
      area,
      checklists,
    });
  }

  async deleteObraAreaChecklist(idObraAreaChecklist: number): Promise<void> {
    await this.service.deleteObraAreaChecklist({
      idObraAreaChecklist,
    });
  }

  async deleteLoteObraAreaChecklist(obraAreaChecklistIds: number[]): Promise<void> {
    await this.service.deleteLoteObraAreaChecklist({
      obraAreaChecklistIds,
    });
  }

  async getStatInformationByIdObra(idObra: number): Promise<StatInformation> {
    return await this.service.getStatInformationByIdObra({ idObra });
  }

  async createAreaChecklistServicos(areas: number[], checklists: number[]): Promise<void> {
    await this.service.createAreaChecklistServicos({
      areas,
      checklists,
    });
  }

  async deleteAreaChecklistServicos(areas: number[], checklists: number[]): Promise<void> {
    await this.service.deleteAreaChecklistServicos({
      areas,
      checklists,
    });
  }

  async copyObraAreaChecklist(idObraAreaChecklist: number, area: string, copiarChecklist: boolean): Promise<void> {
    await this.service.copyObraAreaChecklist({
      idObraAreaChecklist,
      area,
      copiarChecklist,
    });
  }

  //#region GestaoResiduos
  async getObrasGestaoResiduosList(request: GetAllObrasGestaoDeResiduosRequest): Promise<Paginated<GetAllObrasGestaoDeResiduosData>> {
    const response = await this.service.getObrasGestaoResiduosList(request);
    return { ...response };
  }

  async deleteGestaoResiduos(request: { id: number }): Promise<void> {
    await this.service.deleteGestaoResiduos(request);
  }

  async postGestaoResiduosCreate(request: CreateObrasGestaoDeResiduosRequest): Promise<number> {
    const response = await this.service.postGestaoResiduosCreate(request);
    return response;
  }

  async getByIdGestaoResiduos(request: { id: number }): Promise<GetByidObrasGestaoDeResiduosResponse> {
    const response = await this.service.getByIdGestaoResiduos(request);
    return { ...response };
  }

  async putGestaoResiduosUpdate(request: UpdateObrasGestaoDeResiduosRequest): Promise<void> {
    await this.service.putGestaoResiduosUpdate(request);
  }
  //#endregion

  //#region ControleMateriais
  async getAllControleMateriaisList(request: GetAllControleMateriaisRequest): Promise<GetAllControleMateriaisResponse> {
    const response = await this.service.getAllControleMateriaisList(request);
    return { ...response };
  }

  async deleteControleMateriais(request: { id: number }): Promise<void> {
    await this.service.deleteControleMateriais(request);
  }

  async postControleMateriaisCreate(request: CreateControleMateriaisRequest): Promise<number> {
    const response = await this.service.postControleMateriaisCreate(request);
    return response;
  }

  async getByIdControleMateriais(request: { id: number }): Promise<GetControleMateriaisByIdResponse> {
    const response = await this.service.getByIdControleMateriais(request);
    return { ...response };
  }

  async updateControleMateriais(request: UpdateControleMateriaisRequest): Promise<void> {
    await this.service.updateControleMateriais(request);
  }
  //#endregion

  //#region ControleServicos
  async getAllControleServicosList(request: GetAllControleServicosRequest): Promise<GetAllControleServicosResponse> {
    const response = await this.service.getAllControleServicosList(request);
    return { ...response };
  }

  async deleteControleServicos(request: { id: number }): Promise<void> {
    await this.service.deleteControleServicos(request);
  }

  async postControleServicosCreate(request: CreateControleServicosRequest): Promise<number> {
    const response = await this.service.postControleServicosCreate(request);
    return response;
  }

  async getByIdControleServicos(request: { id: number }): Promise<GetControleServicosByIdResponse> {
    const response = await this.service.getByIdControleServicos(request);
    return { ...response };
  }

  async updateControleServicos(request: UpdateControleServicosRequest): Promise<void> {
    await this.service.updateControleServicos(request);
  }
  //#endregion

  async getObraAreaChecklistHeader(idObraAreaChecklist: number): Promise<ObraAreaChecklistHeader> {
    const response = await this.service.getObraAreaChecklistHeader({ idObraAreaChecklist });
    return response.item;
  }

  async getAllObraChecklistServico(
    idObra: number,
    idObraAreaChecklist: number,
    statusChecklist: number | null,
    statusVerificacao: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ObraChecklistServico>> {
    return await this.service.getAllObraChecklistServico({
      idObra,
      idObraAreaChecklist,
      statusChecklist,
      statusVerificacao,
      page,
      rowsPerPage,
    });
  }

  //#region  ObrasMateriaisControlados
  async getAllObrasMateriaisControladosList(
    request: GetAllObrasMateriaisControladosRequest,
  ): Promise<GetAllObrasMateriaisControladosResponse> {
    const response = await this.service.getAllObrasMateriaisControladosList(request);
    return { ...response };
  }

  async deleteObraMateriaisControlados(request: { id: number }): Promise<void> {
    await this.service.deleteObraMateriaisControlados(request);
  }

  async obrasMateriaisControladosDropdown(request: { id: number }): Promise<GetObraMateriaisControladosDropDown[]> {
    const response = await this.service.obrasMateriaisControladosDropdown(request);
    return response;
  }

  async postObraMateriaisControladosCreate(request: CreateObraMateriaisControladosRequest): Promise<number> {
    const response = await this.service.postObraMateriaisControladosCreate(request);
    return response;
  }

  //#endregion

  //#region ObrasServicosControlados
  async getAllObrasServicosControladosList(
    request: GetAllObrasServicosControladosRequest,
  ): Promise<GetAllObrasServicosControladosResponse> {
    const response = await this.service.getAllObrasServicosControladosList(request);
    return { ...response };
  }

  async deleteObraServicosControlados(request: { id: number }): Promise<void> {
    await this.service.deleteObraServicosControlados(request);
  }

  async obrasServicosControladosDropdown(request: { id: number }): Promise<GetObraServicosControladosDropDown[]> {
    const response = await this.service.obrasServicosControladosDropdown(request);
    return response;
  }

  async postObraServicosControladosCreate(request: CreateObraServicosControladosRequest): Promise<number> {
    const response = await this.service.postObraServicosControladosCreate(request);
    return response;
  }
  //#endregion
  async createObraChecklistServicos(idObra: number, idObraAreaChecklist: number, checklistServicos: number[]): Promise<void> {
    await this.service.createObraChecklistServicos({
      idObra,
      idObraAreaChecklist,
      checklistServicos,
    });
  }

  async deleteObraChecklistServicos(idsObraChecklistServicos: number[]): Promise<void> {
    await this.service.deleteObraChecklistServicos({ idsObraChecklistServicos });
  }

  async getObraChecklistServicoHeader(idObraChecklistServico: number): Promise<ObraChecklistServicoHeader> {
    const response = await this.service.getObraChecklistServicoHeader({
      idObraChecklistServico,
    });
    return response.item;
  }

  async getAllInspecaoObra(
    idObraChecklistServico: number,
    data: Date | null,
    localizacao: string | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<InspecaoObra>> {
    return await this.service.getAllInspecaoObra({
      idObraChecklistServico,
      data,
      localizacao,
      status,
      page,
      rowsPerPage,
    });
  }

  async getObraChecklistServicoStatisticas(idObraChecklistServico: number): Promise<ObraChecklistServicoEstatisticas | null> {
    const response = await this.service.getObraChecklistServicoStatisticas({
      idObraChecklistServico,
    });
    return response.item;
  }

  async updateStatusObraChecklistServico(idObraChecklistServico: number, status: number): Promise<void> {
    await this.service.updateStatusObraChecklistServico({
      idObraChecklistServico,
      status,
    });
  }

  async updateMetaObraChecklistServico(idObraChecklistServico: number, metaAprovacao: number): Promise<void> {
    await this.service.updateMetaObraChecklistServico({
      idObraChecklistServico,
      metaAprovacao,
    });
  }

  async updateInspecaoObraAprovacaoLote(idFuncionario: number, idsInspecaoObra: number[], dataAprovacao: Date): Promise<void> {
    await this.service.updateInspecaoObraAprovacaoLote({
      idFuncionario,
      idsInspecaoObra,
      dataAprovacao,
    });
  }

  async getObraChecklistServicoCampos(idObraChecklistServico: number): Promise<ObraChecklistServicoCampos | null> {
    const response = await this.service.getObraChecklistServicoCampos({
      idObraChecklistServico,
    });
    return response.item;
  }

  async createInspecaoObra(
    idObraChecklistServico: number,
    data: Date,
    campo1: string | null,
    campo2: string | null,
    campo3: string | null,
    campo4: string | null,
  ): Promise<void> {
    await this.service.createInspecaoObra({
      idObraChecklistServico,
      data,
      campo1,
      campo2,
      campo3,
      campo4,
    });
  }

  async updateInspecaoObra(
    idInspecaoObra: number,
    data: Date,
    campo1: string | null,
    campo2: string | null,
    campo3: string | null,
    campo4: string | null,
  ): Promise<void> {
    await this.service.updateInspecaoObra({
      idInspecaoObra,
      data,
      campo1,
      campo2,
      campo3,
      campo4,
    });
  }

  async deleteInspecaoObra(idInspecaoObra: number): Promise<void> {
    await this.service.deleteInspecaoObra({
      idInspecaoObra,
    });
  }

  async copyInspecaoObra(idInspecaoObra: number, copyNumber: number): Promise<void> {
    await this.service.copyInspecaoObra({
      idInspecaoObra,
      copyNumber,
    });
  }

  async getInspecaoObraById(idInspecaoObra: number): Promise<InspecaoObraDetalhes | null> {
    const response = await this.service.getInspecaoObraById({ idInspecaoObra });
    return response.item;
  }

  async getAllInspecaoObraItem(idInspecaoObra: number, page: number, rowsPerPage: number): Promise<Paginated<InspecaoObraItem>> {
    return await this.service.getAllInspecaoObraItem({
      idInspecaoObra,
      page,
      rowsPerPage,
    });
  }

  async getAllExecutadoPor(idInspecaoObra: number, page: number, rowsPerPage: number): Promise<Paginated<ExecutadoPor>> {
    return await this.service.getAllExecutadoPor({
      idInspecaoObra,
      page,
      rowsPerPage,
    });
  }

  async getAllInspecaoObraOcorrencia(
    idInspecaoObra: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<InspecaoObraOcorrencia>> {
    return await this.service.getAllInspecaoObraOcorrencia({
      idInspecaoObra,
      page,
      rowsPerPage,
    });
  }

  async createInspecaoObraOcorrencia(
    idObra: number,
    idInspecaoObra: number,
    idInspecaoObraItens: number | null,
    inspecao: number | null,
    descricao: string,
    dataDescricao: Date | null,
    tratativa: string | null,
    dataTratativa: Date | null,
  ): Promise<void> {
    await this.service.createInspecaoObraOcorrencia({
      idObra,
      idInspecaoObra,
      idInspecaoObraItens,
      inspecao,
      descricao,
      dataDescricao,
      tratativa,
      dataTratativa,
    });
  }

  async updateInspecaoObraOcorrencia(
    idObra: number,
    idInspecaoObra: number,
    idInformacoesInspecaoObra: number,
    idInspecaoObraItens: number | null,
    inspecao: number | null,
    descricao: string,
    dataDescricao: Date | null,
    tratativa: string | null,
    dataTratativa: Date | null,
  ): Promise<void> {
    await this.service.updateInspecaoObraOcorrencia({
      idObra,
      idInspecaoObra,
      idInformacoesInspecaoObra,
      idInspecaoObraItens,
      inspecao,
      descricao,
      dataDescricao,
      tratativa,
      dataTratativa,
    });
  }

  async getAllAtributosObrasCadastroList(): Promise<GetAllAtributosObrasCadastroResponse> {
    const response = await this.service.getAllAtributosObrasCadastroList();
    return { ...response };
  }

  async updateAtributosObrasCadastro(
    idAtributosObras: number,
    exibirDataChecklist: boolean,
    exibirDataInspecao: boolean,
    exibirDataAprovacaoFinal: boolean,
  ): Promise<void> {
    await this.service.updateAtributosObrasCadastro({
      idAtributosObras,
      exibirDataChecklist,
      exibirDataInspecao,
      exibirDataAprovacaoFinal,
    });
  }
  async deleteInspecaoObraOcorrencia(idObra: number, idInspecaoObra: number, idInformacoesInspecaoObra: number): Promise<void> {
    await this.service.deleteInspecaoObraOcorrencia({
      idObra,
      idInspecaoObra,
      idInformacoesInspecaoObra,
    });
  }

  async createInspecaoObraExecutadoPor(
    idObra: number,
    idInspecaoObra: number,
    realizadoPor: number,
    idFornecedor: number | null,
    funcionarios: number[] | null,
  ): Promise<void> {
    await this.service.createInspecaoObraExecutadoPor({
      idObra,
      idInspecaoObra,
      realizadoPor,
      idFornecedor,
      funcionarios,
    });
  }

  async deleteInspecaoObraExecutadoPor(idObra: number, idInspecaoObra: number, idExecutadoPor: number): Promise<void> {
    await this.service.deleteInspecaoObraExecutadoPor({
      idObra,
      idInspecaoObra,
      idExecutadoPor,
    });
  }

  async updateInspecaoObraWithValidation(
    idObra: number,
    idInspecaoObra: number,
    idFuncionarioInspecionado: number | null,
    idFuncionarioAprovado: number | null,
    status: number,
    dataEncerramento: Date | null,
    arquivo1: File | null,
    limparArquivo1: boolean,
    arquivo2: File | null,
    limparArquivo2: boolean,
    arquivo3: File | null,
    limparArquivo3: boolean,
    arquivo4: File | null,
    limparArquivo4: boolean,
    arquivo5: File | null,
    limparArquivo5: boolean,
    observacoes: string | null,
    descricaoArquivo1: string | null,
    descricaoArquivo2: string | null,
    descricaoArquivo3: string | null,
    descricaoArquivo4: string | null,
    descricaoArquivo5: string | null,
    inspecaoObraItens: {
      idInspecaoObraItem: number;
      inspecao1: string;
      dataInspecao1: Date | null;
      inspecao2: string;
      dataInspecao2: Date | null;
    }[],
  ): Promise<void> {
    await this.service.updateInspecaoObraWithValidation({
      idObra,
      idInspecaoObra,
      idFuncionarioInspecionado,
      idFuncionarioAprovado,
      status,
      dataEncerramento,
      arquivo1,
      limparArquivo1,
      arquivo2,
      limparArquivo2,
      arquivo3,
      limparArquivo3,
      arquivo4,
      limparArquivo4,
      arquivo5,
      limparArquivo5,
      observacoes,
      descricaoArquivo1,
      descricaoArquivo2,
      descricaoArquivo3,
      descricaoArquivo4,
      descricaoArquivo5,
      inspecaoObraItens,
    });
  }

  async getInspecaoObraImage(idInspecaoObra: number, imagePosition: number): Promise<Blob> {
    return await this.service.getInspecaoObraImage({ idInspecaoObra, imagePosition });
  }

  async getAllChecklistServico(
    tipoCampo: number | null,
    valorCampo: string | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ChecklistServico>> {
    return await this.service.getAllChecklistServico({
      tipoCampo,
      valorCampo,
      status,
      page,
      rowsPerPage,
    });
  }

  async createChecklistServico(
    ativo: boolean,
    codigo: string,
    nroRevisao: string,
    descricao: string,
    tipoServico: number,
    unidade: string | null,
    campo1: string,
    campo2: string,
    campo3: string,
    campo4: string,
  ): Promise<void> {
    await this.service.createChecklistServico({
      ativo,
      codigo,
      nroRevisao,
      descricao,
      tipoServico,
      unidade,
      campo1,
      campo2,
      campo3,
      campo4,
    });
  }

  async updateChecklistServico(
    idChecklistServico: number,
    ativo: boolean,
    codigo: string,
    nroRevisao: string,
    descricao: string,
    tipoServico: number,
    unidade: string | null,
    campo1: string,
    campo2: string,
    campo3: string,
    campo4: string,
  ): Promise<void> {
    await this.service.updateChecklistServico({
      idChecklistServico,
      ativo,
      codigo,
      nroRevisao,
      descricao,
      tipoServico,
      unidade,
      campo1,
      campo2,
      campo3,
      campo4,
    });
  }

  async deleteChecklistServico(idChecklistServico: number): Promise<void> {
    await this.service.deleteChecklistServico({
      idChecklistServico,
    });
  }

  async copyChecklistServico(
    idChecklistServico: number,
    codigo: string,
    nroRevisao: string,
    descricao: string,
  ): Promise<void> {
    await this.service.copyChecklistServico({
      idChecklistServico,
      codigo,
      nroRevisao,
      descricao,
    });
  }

  async getChecklistServicoById(idChecklistServico: number): Promise<ChecklistServicoDetalhe | null> {
    const response = await this.service.getChecklistServicoById({
      idChecklistServico,
    });
    return response.item;
  }

  async getAllItemChecklistServico(
    idChecklistServicoAmbiente: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ItemChecklistServico>> {
    return await this.service.getAllItemChecklistServico({
      idChecklistServicoAmbiente,
      page,
      rowsPerPage,
    });
  }

  async createItemChecklistServico(idChecklistServicoAmbiente: number, ordem: string, descricao: string, resumoItem: string | null, metodoVerificacao: string | null, tolerancia: string | null): Promise<void> {
    await this.service.createItemChecklistServico({
      idChecklistServicoAmbiente,
      ordem,
      descricao,
      resumoItem,
      metodoVerificacao,
      tolerancia,
    });
  }

  async updateItemChecklistServico(
    idItemChecklistServico: number,
    ordem: string,
    descricao: string,
    resumoItem: string | null,
    metodoVerificacao: string | null,
    tolerancia: string | null,
  ): Promise<void> {
    await this.service.updateItemChecklistServico({
      idItemChecklistServico,
      ordem,
      descricao,
      resumoItem,
      metodoVerificacao,
      tolerancia,
    });
  }

  async deleteItemChecklistServico(idItemChecklistServico: number): Promise<void> {
    await this.service.deleteItemChecklistServico({
      idItemChecklistServico,
    });
  }

  async getEstatisticasChecklistServico(idChecklistServico: number): Promise<EstatisticasChecklistServico> {
    const response = await this.service.getEstatisticasChecklistServico({
      idChecklistServico,
    });
    return response.item;
  }

  // #region SUSTENTABILIDADE

  // #region Controle de Resíduo
  async getAllControleResiduo(request: GetAllControleResiduoRequestModel): Promise<GetAllControleResiduoResponseModel> {
    const response = await this.service.getAllControleResiduo(request);
    return { ...response };
  }

  async getControleResiduoById(request: GetControleResiduoByIdRequestModel): Promise<GetControleResiduoByIdResponseModel> {
    const response = await this.service.getControleResiduoById(request);
    return { ...response.item };
  }

  async createControleResiduo(request: CreateControleResiduoRequestModel): Promise<CreateControleResiduoResponseModel> {
    const response = await this.service.createControleResiduo(request);
    return { ...response };
  }

  async updateControleResiduo(request: UpdateControleResiduoRequestModel): Promise<UpdateControleResiduoResponseModel> {
    const response = await this.service.updateControleResiduo(request);
    return { ...response };
  }

  async deleteControleResiduo(request: DeleteControleResiduoRequestModel): Promise<DeleteControleResiduoResponseModel> {
    const response = await this.service.deleteControleResiduo(request);
    return { ...response };
  }
  // #endregion

  // #region Controle de Energia
  async getAllControleEnergia(request: GetAllControleEnergiaRequestModel): Promise<GetAllControleEnergiaResponseModel> {
    const response = await this.service.getAllControleEnergia(request);
    return { ...response };
  }

  async getControleEnergiaById(request: GetControleEnergiaByIdRequestModel): Promise<GetControleEnergiaByIdResponseModel> {
    const response = await this.service.getControleEnergiaById(request);
    return { ...response.item };
  }

  async createControleEnergia(request: CreateControleEnergiaRequestModel): Promise<CreateControleEnergiaResponseModel> {
    const response = await this.service.createControleEnergia(request);
    return { ...response };
  }

  async updateControleEnergia(request: UpdateControleEnergiaRequestModel): Promise<UpdateControleEnergiaResponseModel> {
    const response = await this.service.updateControleEnergia(request);
    return { ...response };
  }

  async deleteControleEnergia(request: DeleteControleEnergiaRequestModel): Promise<DeleteControleEnergiaResponseModel> {
    const response = await this.service.deleteControleEnergia(request);
    return { ...response };
  }
  // #endregion

  // #region Controle de Água
  async getAllControleAgua(request: GetAllControleAguaRequestModel): Promise<GetAllControleAguaResponseModel> {
    const response = await this.service.getAllControleAgua(request);
    return { ...response };
  }

  async getControleAguaById(request: GetControleAguaByIdRequestModel): Promise<GetControleAguaByIdResponseModel> {
    const response = await this.service.getControleAguaById(request);
    return { ...response.item };
  }

  async createControleAgua(request: CreateControleAguaRequestModel): Promise<CreateControleAguaResponseModel> {
    const response = await this.service.createControleAgua(request);
    return { ...response };
  }

  async updateControleAgua(request: UpdateControleAguaRequestModel): Promise<UpdateControleAguaResponseModel> {
    const response = await this.service.updateControleAgua(request);
    return { ...response };
  }

  async deleteControleAgua(request: DeleteControleAguaRequestModel): Promise<DeleteControleAguaResponseModel> {
    const response = await this.service.deleteControleAgua(request);
    return { ...response };
  }
  // #endregion

  // #endregion


  //#region MAQUINAS EQUIPAMENTOS (PÁGINA DE OBRA EQUIPAMENTO CRÍTICO)

  async getAllManutencaoEquipObra(
    idObra: number,
    page: number | null,
    rowsPerPage: number | null
  ): Promise<Paginated<ManutencaoEquipObraLista>> {
    const response = await this.service.getAllManutencaoEquipObra({
      idObra,
      page: page ?? undefined,
      rowsPerPage: rowsPerPage ?? undefined,
    })

    return { ...response };

  }

  async getManutencaoEquipObraById(idManutencaoEquipObra: number): Promise<ManutencaoEquipObra> {
    const response = await this.service.getManutencaoEquipObraById({ idManutencaoEquipObra: idManutencaoEquipObra });
    return response;

  }

  async createManutencaoEquipObra(
    form: ManutencaoEquipObra
  ): Promise<number> {
    const response = await this.service.createManutencaoEquipObra({ ...form });
    return response.idManutencaoEquipObra;
  }

  async updateManutencaoEquipObra(
    form: ManutencaoEquipObra
  ): Promise<void> {
    await this.service.updateManutencaoEquipObra({ ...form });

  }

  async deleteManutencaoEquipObra(idManutencaoEquipObra: number): Promise<void> {
    const response = await this.service.deleteManutencaoEquipObra(idManutencaoEquipObra);
    return response;

  }

  //#endregion


  async downloadObraDocumento(
    idObraArquivo: number,
  ): Promise<Blob> {
    return await this.service.downloadObraDocumento({ idObraArquivo });
  }

  async getDashboardObrasInformation(
  ): Promise<DashboardObras> {
    const response = await this.service.getDashboardObrasInformation({});
    return response.item;
  }

  async getRestricoesPainelObra(): Promise<RestricoesPainelObra> {
    const response = await this.service.getRestricoesPainelObra({});
    return response;
  }

  async deleteSelectedItemChecklistServico(
    idsItemChecklistServico: number[],
  ): Promise<void> {
    await this.service.deleteSelectedItemChecklistServico({
      idsItemChecklistServico,
    });
  }

  async downloadMateriaisControladosById(
    idMateriaisControlados: number,
  ): Promise<Blob> {
    return await this.service.downloadMateriaisControladosById({
      idMateriaisControlados,
    });
  }

  async aprovacaoFinalMapaConcretagem(
    idMapaConcretagem: number,
    idFuncionario: number,
    dataAprovacao: Date,
  ): Promise<void> {
    await this.service.aprovacaoFinalMapaConcretagem({
      idMapaConcretagem,
      idFuncionario,
      aprovFinalDate: dataAprovacao,
    });
  }

  async getIndicadoresServicosObras(
    idObra: number,
  ): Promise<IndicadoresServicosObra> {
    const response = await this.service.getIndicadoresServicosObras({
      idObra,
    });
    return response.item;
  }

  async getChecklistServicosByIdObraDropDown(
    idObra: number,
    idObraAreaChecklist: number,
    tipoServico: number | undefined,
  ): Promise<ChecklistServicoDropDown[]> {
    const response = await this.service.getChecklistServicosByIdObraDropDown({
      idObra,
      idObraAreaChecklist,
      tipoServico
    });
    return response.itens;
  }

  async downloadAlvenariaEstrutura(
    idAlvenariaObra: number,
    nroArquivo: number,
  ): Promise<Blob> {
    return await this.service.downloadAlvenariaEstrutura({
      idAlvenariaObra,
      nroArquivo,
    });
  }

  //#region ChecklistServicoAmbiente

  async getChecklistServicoAmbienteById(idChecklistServicoAmbiente: number)
    : Promise<ChecklistServicoAmbienteModel> {
    const response = await this.service.getChecklistServicoAmbienteById({
      idChecklistServicoAmbiente,
    });
    return response;
  }

  async getAllChecklistServicoAmbientes(
    idChecklistServico: number,
    descricao?: string,
    page?: number,
    rowsPerPage?: number,
  ): Promise<Paginated<ChecklistServicoAmbienteModel>> {
    return await this.service.getAllChecklistServicoAmbientes({
      idChecklistServico,
      descricao,
      page,
      rowsPerPage,
    });
  }

  async deleteChecklistServicoAmbienteById(idChecklistServicoAmbiente: number): Promise<void> {
    await this.service.deleteChecklistServicoAmbienteById(idChecklistServicoAmbiente);
  }

  async createChecklistServicoAmbiente(
    idChecklistServico: number,
    descricao?: string | null,
    ordem?: string | null,
  ): Promise<number> {
    const response = await this.service.createChecklistServicoAmbiente({
      idChecklistServico,
      descricao,
      ordem,
    });
    return response.idChecklistServicoAmbiente;
  }

  async updateChecklistServicoAmbiente(
    idChecklistServicoAmbiente: number,
    descricao?: string | null,
    ordem?: string | null,
  ): Promise<void> {
    await this.service.updateChecklistServicoAmbiente({
      idChecklistServicoAmbiente,
      descricao,
      ordem,
    });
  }

  async copiaChecklistServicoAmbiente(
    idChecklistServicoAmbiente: number,
    descricao?: string,
    ordem?: string,
  ): Promise<void> {
    await this.service.copiaChecklistServicoAmbiente({
      idChecklistServicoAmbiente,
      descricao,
      ordem,
    });
  }

  //#endregion

  async downloadMapaConcretagemArquivo(
    idMapaConcretagem: number,
    nroArquivo: number,
  ): Promise<Blob> {
    return await this.service.downloadMapaConcretagemArquivo({
      idMapaConcretagem,
      nroArquivo,
    });
  }

  async downloadEquipamentoMedicaoArquivo(
    idEquipamentoMedicao: number,
    nroArquivo: number,
  ): Promise<Blob> {
    return await this.service.downloadEquipamentoMedicaoArquivo({
      idEquipamentoMedicao,
      nroArquivo,
    });
  }

  async getReinspecaoEmAberto(
    idObra: number,
    area?: string,
    idsObraChecklistServicos?: number[],
    page?: number,
    rowsPerPage?: number,
  ): Promise<Paginated<ReinspecaoEmAbertoLista>> {
    return await this.service.getReinspecaoEmAbertoLista({
      idObra,
      area,
      idsObraChecklistServicos,
      page,
      rowsPerPage,
    });
  }

  async getObraChecklistServicoLiberacaoById(idObraChecklistServico: number, idChecklistServico: number): Promise<ObraChecklistServicoLiberacao> {
    return await this.service.getObraChecklistServicoLiberacaoById({ idObraChecklistServico, idChecklistServico });
  }

  async saveObraChecklistServicoLiberacao(idObraChecklistServico: number, idChecklistServico: number, form: ObraChecklistServicoLiberacaoForm): Promise<void> {
    await this.service.saveObraChecklistServicoLiberacao({ idObraChecklistServico, idChecklistServico, ...form });
  }

  async getAllChecklistServicoLiberacao(
    idChecklistServico: number,
    descricao: string | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ChecklistServicoLiberacao>> {
    return await this.service.getAllChecklistServicoLiberacao({
      idChecklistServico,
      descricao,
      page,
      rowsPerPage,
    });
  }

  async getChecklistServicoLiberacaoById(
    idChecklistServicoLiberacao: number,
  ): Promise<ChecklistServicoLiberacao> {
    return await this.service
      .getChecklistServicoLiberacaoById({ idChecklistServicoLiberacao });
  }

  async createChecklistServicoLiberacao(
    idChecklistServico: number,
    ordem: string,
    descricao: string,
  ): Promise<number> {
    const response = await this.service
      .createChecklistServicoLiberacao({ idChecklistServico, ordem, descricao });
    return response.idChecklistServicoLiberacao;
  }

  async updateChecklistServicoLiberacao(
    idChecklistServicoLiberacao: number,
    ordem: string,
    descricao: string,
  ): Promise<void> {
    await this.service
      .updateChecklistServicoLiberacao({ idChecklistServicoLiberacao, ordem, descricao });
  }

  async deleteChecklistServicoLiberacao(
    idChecklistServicoLiberacao: number,
  ): Promise<void> {
    await this.service
      .deleteChecklistServicoLiberacao({ idChecklistServicoLiberacao });
  }
}
